<template>
    <div class="mc-search-bar">
        <div class="mc-search-bar-input">
            <el-input :placeholder="searchLabel" v-model="currentValue" @keyup.native.enter="searchSubmit"></el-input>
        </div>
        <el-button class="mc-search-bar-btn" type="primary" icon="el-icon-search" @click="searchSubmit" size="mini"></el-button>
        <el-button class="mc-search-bar-btn" type="danger" icon="el-icon-close" @click="$_reset" size="mini" v-if="value"></el-button>
    </div>
</template>

<script>
    export default {
        name: "mc-search-bar",
        props: {
            value: {
                type: String,
                default: ''
            },
            searchLabel: {
                type: String,
                default: "请输入..."
            },
            searchSubmit: {
                type: Function,
                default: () => {}
            }
        },
        computed: {
            currentValue: {
                get: function () {
                    return this.value
                },
                set: function (val) {
                    this.$emit('input', val)
                }
            }
        },
        methods: {
            $_reset() {
                this.currentValue = '';
                this.searchSubmit();
            },
        },
    };
</script>

<style lang="less" scoped>
    .mc-search-bar {
        // width: 100%;
        height: 100%;
        display: flex;

        .mc-search-bar-input {
            width: 300px;
            margin-right: 10px;
        }

        .mc-search-bar-btn {
            height: 40px;
        }
    }
</style>